import { timeParse } from 'd3'

const highConviction = [
  {
    "ticker": "1928.HK",
    "date": "2015-05-31",
    "report_period": "201505",
    "holding_percentage": ""
  },
  {
    "ticker": "1928.HK",
    "date": "2015-06-30",
    "report_period": "201506",
    "holding_percentage": "0.1967"
  },
  {
    "ticker": "1928.HK",
    "date": "2015-07-31",
    "report_period": "201507",
    "holding_percentage": "0.3379"
  },
  {
    "ticker": "1928.HK",
    "date": "2015-08-31",
    "report_period": "201508",
    "holding_percentage": "0.2717"
  },
  {
    "ticker": "1928.HK",
    "date": "2015-09-30",
    "report_period": "201509",
    "holding_percentage": "0.1394"
  },
  {
    "ticker": "1928.HK",
    "date": "2015-10-31",
    "report_period": "201510",
    "holding_percentage": "0.2647"
  },
  {
    "ticker": "1928.HK",
    "date": "2015-11-30",
    "report_period": "201511",
    "holding_percentage": "0.2665"
  },
  {
    "ticker": "1928.HK",
    "date": "2015-12-31",
    "report_period": "201512",
    "holding_percentage": "0.1487"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-01-31",
    "report_period": "201601",
    "holding_percentage": "0.3178"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-02-29",
    "report_period": "201602",
    "holding_percentage": "0.3079"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-03-31",
    "report_period": "201603",
    "holding_percentage": "0.1518"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-04-30",
    "report_period": "201604",
    "holding_percentage": "0.2176"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-05-31",
    "report_period": "201605",
    "holding_percentage": "0.2291"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-06-30",
    "report_period": "201606",
    "holding_percentage": "0.2041"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-07-31",
    "report_period": "201607",
    "holding_percentage": "0.3569"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-08-31",
    "report_period": "201608",
    "holding_percentage": "0.3265"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-09-30",
    "report_period": "201609",
    "holding_percentage": "0.2097"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-10-31",
    "report_period": "201610",
    "holding_percentage": "0.2392"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-11-30",
    "report_period": "201611",
    "holding_percentage": "0.2977"
  },
  {
    "ticker": "1928.HK",
    "date": "2016-12-31",
    "report_period": "201612",
    "holding_percentage": "0.1704"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-01-31",
    "report_period": "201701",
    "holding_percentage": "0.2812"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-02-28",
    "report_period": "201702",
    "holding_percentage": "0.236"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-03-31",
    "report_period": "201703",
    "holding_percentage": "0.1241"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-04-30",
    "report_period": "201704",
    "holding_percentage": "0.2031"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-05-31",
    "report_period": "201705",
    "holding_percentage": "0.3086"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-06-30",
    "report_period": "201706",
    "holding_percentage": "0.1553"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-07-31",
    "report_period": "201707",
    "holding_percentage": "0.3539"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-08-31",
    "report_period": "201708",
    "holding_percentage": "0.2488"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-09-30",
    "report_period": "201709",
    "holding_percentage": "0.1498"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-10-31",
    "report_period": "201710",
    "holding_percentage": "0.261"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-11-30",
    "report_period": "201711",
    "holding_percentage": "0.2694"
  },
  {
    "ticker": "1928.HK",
    "date": "2017-12-31",
    "report_period": "201712",
    "holding_percentage": "0.0867"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-01-31",
    "report_period": "201801",
    "holding_percentage": "0.1738"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-02-28",
    "report_period": "201802",
    "holding_percentage": "0.2298"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-03-31",
    "report_period": "201803",
    "holding_percentage": "0.109"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-04-30",
    "report_period": "201804",
    "holding_percentage": "0.2736"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-05-31",
    "report_period": "201805",
    "holding_percentage": "0.2818"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-06-30",
    "report_period": "201806",
    "holding_percentage": "0.1088"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-07-31",
    "report_period": "201807",
    "holding_percentage": "0.3868"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-08-31",
    "report_period": "201808",
    "holding_percentage": "0.3391"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-09-30",
    "report_period": "201809",
    "holding_percentage": "0.168"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-10-31",
    "report_period": "201810",
    "holding_percentage": "0.4396"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-11-30",
    "report_period": "201811",
    "holding_percentage": "0.3904"
  },
  {
    "ticker": "1928.HK",
    "date": "2018-12-31",
    "report_period": "201812",
    "holding_percentage": "0.1685"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-01-31",
    "report_period": "201901",
    "holding_percentage": "0.4119"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-02-28",
    "report_period": "201902",
    "holding_percentage": "0.3837"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-03-31",
    "report_period": "201903",
    "holding_percentage": "0.1662"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-04-30",
    "report_period": "201904",
    "holding_percentage": "0.3686"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-05-31",
    "report_period": "201905",
    "holding_percentage": "0.3305"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-06-30",
    "report_period": "201906",
    "holding_percentage": "0.2038"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-07-31",
    "report_period": "201907",
    "holding_percentage": "0.3833"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-08-31",
    "report_period": "201908",
    "holding_percentage": "0.413"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-09-30",
    "report_period": "201909",
    "holding_percentage": "0.2315"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-10-31",
    "report_period": "201910",
    "holding_percentage": "0.4402"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-11-30",
    "report_period": "201911",
    "holding_percentage": "0.5358"
  },
  {
    "ticker": "1928.HK",
    "date": "2019-12-31",
    "report_period": "201912",
    "holding_percentage": "0.2927"
  },
  {
    "ticker": "1928.HK",
    "date": "2020-01-31",
    "report_period": "202001",
    "holding_percentage": "0.4675"
  },
  {
    "ticker": "1928.HK",
    "date": "2020-02-29",
    "report_period": "202002",
    "holding_percentage": "0.4466"
  },
  {
    "ticker": "1928.HK",
    "date": "2020-03-31",
    "report_period": "202003",
    "holding_percentage": "0.2588"
  },
  {
    "ticker": "1928.HK",
    "date": "2020-04-30",
    "report_period": "202004",
    "holding_percentage": "0.2795"
  },
  {
    "ticker": "1928.HK",
    "date": "2020-05-31",
    "report_period": "202005",
    "holding_percentage": "0.2883"
  },
  {
    "ticker": "1928.HK",
    "date": "2020-06-30",
    "report_period": "202006",
    "holding_percentage": "0.0423"
  },
  {
    "ticker": "1928.HK",
    "date": "2020-07-31",
    "report_period": "202007",
    "holding_percentage": ""
  },
  {
    "ticker": "1928.HK",
    "date": "2020-08-31",
    "report_period": "202008",
    "holding_percentage": "0.1292"
  },
  {
    "ticker": "1928.HK",
    "date": "2020-09-30",
    "report_period": "202009",
    "holding_percentage": "0.0699"
  },
  {
    "ticker": "1928.HK",
    "date": "2020-10-31",
    "report_period": "202010",
    "holding_percentage": "0.0336"
  }
]

const parseDate = timeParse('%Y-%m-%d')

export default highConviction.map(d => {
  d['date'] = parseDate(d['date'])
  return d
}).sort((a,b) => (
  b.date - a.date
))
